import * as React from "react";

import { PropertyNavigationBar as SharedUiPropertyNavigationBar } from "@shared-ui/lodging-property-details";
import { PropertyStickyBookBar as SharedUiPropertyStickyBookBar } from "@shared-ui/lodging-property-offers";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutPosition } from "uitk-react-layout-position";

import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";

// Custom sticky component while it's being promoted to uitk
import { StackedSticky } from "components/shared/StackedSticky/StackedSticky";

export const WrappedPropertyNavigationBar = PropertyBexApiWrapper(SharedUiPropertyNavigationBar);
export const WrappedStickyBookBar = PropertyBexApiWrapper(SharedUiPropertyStickyBookBar);

const MARKETING_PARAMS = ["semcid", "emlcid", "mdpcid"];

export const PropertyNavigationBar: React.FC<ComponentProps> = ({ context }) => {
  // Do not include the sticky bar for the marketing channels
  const queryParams = context?.queryParams || {};
  const isMktRequest =
    Object.keys(queryParams)
      .map((key) => key.toLocaleLowerCase())
      .filter((key) => MARKETING_PARAMS.includes(key)).length > 0;

  return (
    <UitkLayoutPosition tag="section" type="relative">
      <StackedSticky>
        <UitkSpacing border={["blockend"]}>
          <div>
            <WrappedPropertyNavigationBar context={context} />
          </div>
        </UitkSpacing>
      </StackedSticky>
      {!isMktRequest && (
        <UitkLayoutPosition type="absolute" position={{ right: "three", top: "one" }}>
          <WrappedStickyBookBar context={context} clickTargetRef="startDate" />
        </UitkLayoutPosition>
      )}
    </UitkLayoutPosition>
  );
};

export default PropertyNavigationBar;
